import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "next/navigation";

type UtmValues = {
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  utm_content: string | null;
  utm_term: string | null;
};

const KEY = "utm_params";

const buildUtmParams = (searchParams: URLSearchParams): UtmValues | null => {
  if (!searchParams.toString().includes("utm_")) {
    return null;
  }
  return {
    utm_source: searchParams.get("utm_source"),
    utm_medium: searchParams.get("utm_medium"),
    utm_campaign: searchParams.get("utm_campaign"),
    utm_content: searchParams.get("utm_content"),
    utm_term: searchParams.get("utm_term"),
  };
};

// Persist utm params for session
export const useUtmParams = (): UtmValues | null => {
  const [persistedUtmParams, setPersistedUtmParams] = useState<UtmValues>();
  const searchParams = useSearchParams();
  const currentUtmParams = useMemo(() => buildUtmParams(searchParams), [searchParams]);

  useEffect(() => {
    if (currentUtmParams) {
      window.sessionStorage.setItem(KEY, JSON.stringify(currentUtmParams));
    }
  }, [currentUtmParams]);

  useEffect(() => {
    try {
      const utmParams = window.sessionStorage.getItem(KEY);
      if (utmParams) {
        setPersistedUtmParams(JSON.parse(utmParams));
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  if (currentUtmParams) {
    return currentUtmParams;
  }
  return persistedUtmParams ?? null;
};
